import { render, staticRenderFns } from "./FrontPages.vue?vue&type=template&id=3cef0d0a&"
import script from "./FrontPages.vue?vue&type=script&lang=js&"
export * from "./FrontPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports